import {
  cheerleader,
  givingTogether,
  peoplesChamp,
  teamCaptainCoach,
  youRock,
} from "../../../assets/gifs";

export const badgesAnimations = [
  {
    type: "YouRockThankYou",
    gifToDisplay: youRock,
    badgeName: "Thank you",
    message: "Yay! You have badged with You Rock",
  },
  {
    type: "PeopleChampLeadership",
    gifToDisplay: peoplesChamp,
    badgeName: "The People's Champ",
    message: "Yay! You have badged with The People's Champ",
  },
  {
    type: "CheerleaderMotivator",
    gifToDisplay: cheerleader,
    badgeName: "Motivator",
    message: "Yay! You have badged with Motivator",
  },
  {
    type: "GivingTogetherCommunityService",
    gifToDisplay: givingTogether,
    badgeName: "Giving Together",
    message: "Yay! You have badged with Giving Together",
  },
  {
    type: "TeamcaptainCoach",
    gifToDisplay: teamCaptainCoach,
    badgeName: "Team Captian",
    message: "Yay! You have badged with Team Captian",
  },
];
